// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BQKR","textarea":"styles_textarea__1LeT4"};